import './styles/advanced-filter-modal.scss'

import React       from 'react'
import PropTypes   from 'prop-types'
import { connect } from 'react-redux'

import { Button, Header, Icon, Modal } from 'semantic-ui-react'

import MetadataFilter from './MetadataFilter'
import DateTimeRangeFilter from '../components/DateTimeRangeFilter'
import StringFilter from '../components/StringFilter'

class AdvancedFilterModal extends React.Component {
  static propTypes = {
    trigger: PropTypes.any,
    onApply: PropTypes.func.isRequired,
    filterCriteria: PropTypes.object,
  }

  state = {
    modalOpen: false,
    filterConfig: {},
  }

  UNSAFE_componentWillReceiveProps({ filterCriteria }) {
    const { jobs: { metadataFilters = [], deliveryTimeFilter, idFilters = [], parentIdFilter } = {} } = filterCriteria
    const state = { filterConfig: { metadataFilters, deliveryTimeFilter, idFilters, parentIdFilter } }
    this.setState(state)
  }

  setModalOpen = (modalOpen) => {
    this.setState({ modalOpen })
  }

  updateFilterConfigState = (filterConfig) => {
    this.setState({ filterConfig })
  }

  updateFilterSlice = (slice, value) => {
    this.updateFilterConfigState({ ...this.state.filterConfig, [slice]: value })
  }

  handleMetadataChange = (itemIndex, params) => {
    const newMetadataFilters = [...this.state.filterConfig.metadataFilters]
    newMetadataFilters[itemIndex] = params
    this.updateFilterSlice('metadataFilters', newMetadataFilters)
  }

  handleMetadataAdd = () => {
    const newMetadataFilters = [...this.state.filterConfig.metadataFilters]
    newMetadataFilters.push({ key: '', value: '' })
    this.updateFilterSlice('metadataFilters', newMetadataFilters)
  }

  handleMetadataRemove = (itemIndex) => {
    const newMetadataFilters = [...this.state.filterConfig.metadataFilters]
    newMetadataFilters.splice(itemIndex, 1)
    // Force re-rendering since an index may be removed from start
    this.updateFilterSlice('metadataFilters', [])
    setTimeout(() => {
      this.updateFilterSlice('metadataFilters', newMetadataFilters)
    }, 1)
  }

  handleDeliveryTimeChange = (params) => {
    this.updateFilterSlice('deliveryTimeFilter', params)
  }

  handleIdChange = (id) => {
    const idList = id ? [id] : []
    this.updateFilterSlice('idFilters', idList)
  }

  handleParentIdChange = (id) => {
    this.updateFilterSlice('parentIdFilter', id)
  }

  validate = () => {
    let valid = true
    const metadataFiltersWithError = [...this.state.filterConfig.metadataFilters]
    let usedKeys = []
    metadataFiltersWithError.forEach(function(mf, index) {
      if ((mf.key || '').trim() === '' || (mf.value || '').trim() === '') {
        this[index].error = 'Key or value must not be empty'
        valid = false
      } else if (usedKeys[mf.key]) {
        this[index].error = 'Key must not be used more than once'
        valid = false
      }
      usedKeys[mf.key] = 1
    }, metadataFiltersWithError)
    this.updateFilterSlice('metadataFilters', metadataFiltersWithError)
    return valid
  }

  handleApply = () => {
    if (!this.validate()) {
      return
    }
    this.props.onApply(this.state.filterConfig)
    this.setModalOpen(false)
  }

  render() {
    const { trigger } = this.props
    const { modalOpen, filterConfig } = this.state

    const { metadataFilters = [], deliveryTimeFilter, idFilters = [], parentIdFilter } = filterConfig

    return (
      <Modal
        className="advanced-filter-modal"
        centered={false}
        size="small"
        trigger={trigger}
        open={modalOpen}
        onOpen={() => this.setModalOpen(true)}
        onClose={() => this.setModalOpen(false)}
      >
        <Header icon="filter" content="Advanced Filters" />

        <Modal.Content>
          <div className="section">
            <div className="metadata-filter-header">
              <label>Job Metadata</label>
              <Button icon primary onClick={this.handleMetadataAdd}>
                <Icon name="add" />
              </Button>
            </div>
            { metadataFilters.map((mf, index) => {
              return (
                <MetadataFilter
                  key={`${index}-${mf.error}`}
                  itemIndex={index}
                  defaultFilterConfig={mf}
                  onChange={this.handleMetadataChange}
                  onRemove={this.handleMetadataRemove}
                />
              )
            })}
            {
              metadataFilters.length === 0 && <div className="empty-metadata">Add + icon to add metadata filters...</div>
            }
          </div>

          <div className="section">
            <label>Job ID</label>
            <StringFilter placeholder="ID" defaultValue={idFilters ? idFilters[0] : undefined} onChange={this.handleIdChange} />
          </div>

          <div className="section">
            <label>Parent Job ID</label>
            <StringFilter placeholder="ID" defaultValue={parentIdFilter} onChange={this.handleParentIdChange} />
          </div>

          <div className="section">
            <label>Delivery</label>
            <DateTimeRangeFilter defaultFilterConfig={deliveryTimeFilter} onChange={this.handleDeliveryTimeChange} />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={this.handleApply}>
            Apply <Icon name="chevron right" />
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

const mapDispatchToProps = {}
const mapStateToProps    = (state) => ({
  filterCriteria: state.items.filterCriteria,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdvancedFilterModal)
